export const LANGUAGES = [
  {code: "ar", title: "Arabic"},
  {code: "en", title: "English"},
  {code: "fr", title: "French"},
  {code: "hi", title: "Hindi"},
  {code: "ja", title: "Japanese"},
  {code: "ko", title: "Korean"},
  {code: "es", title: "Spanish"},
];